export default "__VITE_PUBLIC_ASSET__8ce05a72__"